import React from 'react';
import { EYEBROW_STYLE } from './style';

interface NavGroupProps {
  label: string;
  children: React.ReactNode;
}

/** Eyebrow-labelled navigation group for the warm-white sidebar. */
export default function NavGroup({ label, children }: NavGroupProps): JSX.Element {
  return (
    <div className="flex w-full flex-col gap-0.5">
      <p className={EYEBROW_STYLE}>{label}</p>
      {children}
    </div>
  );
}
